import React, { useState, FunctionComponent } from "react";
import {
  Paper,
  Button,
  Grid,
  Typography,
  TextField
} from "@material-ui/core";
import { useUsersStyles } from "../useUsersStyles";
import { Select } from "../../Select";
import { Formik, Form, ErrorMessage } from "formik";
import { useStore } from "../../../store";
import * as yup from "yup";
import { SnackBar } from "../../SnackBar";

const createSchema = yup.object().shape({
  full_name: yup.string().required("Name is required"),

  user_code: yup
    .string()
    .min(2, "Too Short!")
    .max(70, "Too Long!")
    .required("Username is required"),

  email: yup
    .string()
    .email("Invalid email")
    .required("Email is required"),

  pass_code: yup
    .string()
    .min(2, "Too Short!")
    .max(70, "Too Long!")
    .required("Password is required"),

  confirm_pass_code: yup
    .string()
    .required("Confirm Password is required")
    .oneOf([yup.ref("pass_code"), ""], "Passwords must match"),

  address: yup.string().required("Address is required!"),

  division_id: yup
    .string()
    .required("Division is required")
    .nullable(),

  contact_no: yup
    .string()
    .matches(/(^[+]?[0-9]*$)/, {
      message: "Invalid phone number format",
    })
    .required("Contact Number is required!")
    .max(15, "Maximum 15 digits!")
    .nullable(),

  roles: yup
    .string()
    .required("Roles are required")
    .nullable(),
});

const updateSchema = yup.object().shape({
  full_name: yup.string().required("Name is required"),

  email: yup
    .string()
    .email("Invalid email")
    .required("Email is required")
    .nullable(),

  address: yup
    .string()
    .required("Address is required!")
    .nullable(),

  contact_no: yup
    .string()
    .matches(/(^[+]?[0-9]*$)/, {
      message: "Invalid phone number format",
    })
    .required("Contact Number is required!")
    .max(15, "Maximum 15 digits!")
    .nullable(),

  division_id: yup
    .string()
    .required("Division is required")
    .nullable(),

  roles: yup
    .string()
    .required("Roles are required")
    .nullable(),
});

type userParams = {
  userId: string;
  goBackToList: () => void;
};
export const UserForm: FunctionComponent<userParams> = ({
  userId,
  goBackToList,
}) => {
  // interface MatchParams {
  //   id: string;
  // }

  // export const UserForm: FunctionComponent<RouteComponentProps<MatchParams>> = (
  //   props
  // ) => {
  const classes = useUsersStyles();
  const [roles] = useStore("rolesForUser");
  const [userDivisions] = useStore("userDivisions");
  const [status] = useStore("status");
  const [user] = useStore("auth", "user");
  const [users, { createUser, updateUser, getUsers }] = useStore("users");
  const [snackbarColor, setSnackbarColor] = useState<string>("#d50000");
  const [userStatus, setUserStatus] = useState<string>("");
  const [usernameAvailable, setusernameAvailable] = useState<any>(null);
  // const NavLink = React.forwardRef<HTMLAnchorElement, RouterLinkProps>(
  //   (props, ref) => <RouterLink innerRef={ref} {...props} />
  // );

  const checkAvailability = (value: any) => {
    const user_code_list =
      users && users !== undefined
        ? Object.values(users && users).map((value: any) =>
            value.user_code.toLowerCase()
          )
        : "";

    if (user_code_list.includes(value.toLowerCase())) {
      setusernameAvailable(false);
    } else {
      setusernameAvailable(true);
    }
  };
  const updateStoreUser = async (values: any) => {
    try {
      const userUpdateData = {
        full_name: values.full_name,
        address: values.address,
        contact_no: values.contact_no,
        email: values.email,
        division_id: values.division_id.value,
        status: values.status.value,
        roles: values.roles.map((role: any) => role.value),
      };
      await updateUser(userId, userUpdateData);
      getUsers();
      setSnackbarColor("green");
      setUserStatus("User successfully updated");
      setTimeout(() => {
        //setNavigateToUserTable(true);
        goBackToList();
      }, 2000);
    } catch (error:any) {
      setSnackbarColor("red");
      setUserStatus(error.error);
    }
    // }
  };
  const submitForm = async (values: any) => {
    try {
      if (userId === "new") {
        if (usernameAvailable === true) {
          await createUser({
            full_name: values.full_name,
            address: values.address,
            contact_no: values.contact_no,
            email: values.email,
            user_code: values.user_code,
            pass_code: values.pass_code,
            division_id: values.division_id.value,
            roles: values.roles.map((role: any) => role.value),
          });
          getUsers();
          setSnackbarColor("green");
          setUserStatus("User successfully created");
          setTimeout(() => {
            //setNavigateToUserTable(true);
            goBackToList();
          }, 2000);
        } else {
          setSnackbarColor("red");
          setUserStatus("User name already exist");
        }
      } else {
        await updateStoreUser(values);
      }
    } catch (error:any) {
      console.log("error", error);
      setSnackbarColor("red");
      setUserStatus(error.error);
    }
  };
  const onCloseSnackbar = () => {
    setUserStatus("");
  };
  const roleOptions =
    roles &&
    roles.map((item: { [key: string]: any }) => ({
      value: item.id,
      label: item.name,
    }));
  const divisionOptions =
  userDivisions &&
  userDivisions.map((item: { [key: string]: any }) => ({
      value: item.id,
      label: item.name,
    }));
  const statusOptions =
    status &&
    status.map((item: { [key: string]: any }) => ({
      value: item.id,
      label: item.description,
    }));

  const initialValues = {
    full_name: "",
    address: "",
    contact_no: "",
    email: "",
    user_code: "",
    pass_code: "",
    confirm_pass_code: "",
    division_id: "",
    status: "",
    //created_by: "",
    roles: [""],
  };

  if (
    users && users !== undefined
      ? Object.values(users && users).find((value: any) => value.id === userId)
      : ""
  ) {
    const userDetails =
      users && users !== undefined
        ? Object.values(users && users).find(
            (value: any) => value.id === userId
          )
        : "";
    const {
      full_name,
      address,
      contact_no,
      email,
      user_code,
      division_id,
      status,
      roles,
    } = userDetails;
    initialValues.full_name = full_name;
    initialValues.address = address;
    initialValues.user_code = user_code;
    initialValues.email = email;
    initialValues.contact_no = contact_no;
    initialValues.status = statusOptions.find(
      (item: any) => status === item.value
    );
    initialValues.division_id = divisionOptions.find(
      (item: any) => item.value === division_id
    );
    initialValues.roles =
      roles !== undefined
        ? roleOptions.filter((a: any) => roles.find((b: any) => b === a.value))
        : "";
  }

  return (
      <div>
        <SnackBar
          status={userStatus}
          onCloseError={onCloseSnackbar}
          color={snackbarColor}
        />
        <Paper elevation={4} style={{ minHeight: "25em", minWidth: "50%" }}>
          <Grid item>
            <Formik
              enableReinitialize
              validationSchema={userId === "new" ? createSchema : updateSchema}
              initialValues={initialValues}
              onSubmit={(values) => {
                submitForm(values);
              }}
            >
              {({ values, handleChange, setFieldValue, resetForm }) => (
                <Form>
                  <Grid container direction="row">
                    <Grid item xs>
                      <Grid
                        container
                        spacing={5}
                        className={classes.fieldSpace}
                      >
                        <Grid item xs={6}>
                          <Grid container direction="column">
                            <Typography className={classes.fieldLabelStyles}>
                              Full name <span className={classes.asterisk}> * </span>
                            </Typography>
                            <TextField
                              variant="outlined"
                              name="full_name"
                              value={values.full_name}
                              onChange={handleChange}
                              inputProps={{ maxLength: 50 }}
                            />

                            <ErrorMessage name="full_name">
                              {(msg) => (
                                <div style={{ color: "red" }}>{msg}</div>
                              )}
                            </ErrorMessage>
                          </Grid>
                        </Grid>
                        <Grid item xs={6}>
                          <Grid container direction="column">
                            <Typography className={classes.fieldLabelStyles}>
                              Address<span className={classes.asterisk}> * </span>
                            </Typography>
                            <TextField
                              variant="outlined"
                              name="address"
                              value={values.address}
                              multiline
                              rowsMax={4}
                              onChange={handleChange}
                              inputProps={{ maxLength: 50 }}
                            />
                            <ErrorMessage name="address">
                              {(msg) => (
                                <div style={{ color: "red" }}>{msg}</div>
                              )}
                            </ErrorMessage>
                          </Grid>
                        </Grid>
                        <Grid item xs={6}>
                          <Grid container direction="column">
                            <Typography className={classes.fieldLabelStyles}>
                              Email<span className={classes.asterisk}> * </span>
                            </Typography>
                            <TextField
                              variant="outlined"
                              name="email"
                              type="email"
                              value={values.email}
                              onChange={handleChange}
                              inputProps={{ maxLength: 50 }}
                            />
                            <ErrorMessage name="email">
                              {(msg) => (
                                <div style={{ color: "red" }}>{msg}</div>
                              )}
                            </ErrorMessage>
                          </Grid>
                        </Grid>
                        <Grid item xs={6}>
                          <Grid container direction="column">
                            <Typography className={classes.fieldLabelStyles}>
                              Contact Number<span className={classes.asterisk}> * </span>
                            </Typography>
                            <TextField
                              variant="outlined"
                              name="contact_no"
                              onChange={handleChange}
                              value={values.contact_no}
                              inputProps={{ maxLength: 50 }}
                            />
                            <ErrorMessage name="contact_no">
                              {(msg) => (
                                <div style={{ color: "red" }}>{msg}</div>
                              )}
                            </ErrorMessage>
                          </Grid>
                        </Grid>
                        <Grid item xs={6}>
                          <Grid container direction="column">
                            <Typography className={classes.fieldLabelStyles}>
                              Username<span className={classes.asterisk}> * </span>
                            </Typography>
                            <TextField
                              variant="outlined"
                              name="user_code"
                              value={values.user_code}
                              onChange={(e) => {
                                handleChange(e);
                                const domain = e.target.value; //.replace(/.*@/, '')
                                setFieldValue("user_code", domain);
                                checkAvailability(domain);
                              }}
                              disabled={userId !== "new" ? true : false}
                              // onClick={()=>{

                              //  setusernameAvailable()
                              // }}
                              inputProps={{ maxLength: 50 }}
                            />
                            {// usernameAvailable===true?<div>username available</div>:usernameAvailable===false?<div>username exist</div>:<div>
                            // </div>
                            values.user_code ? (
                              usernameAvailable === true ? (
                                <Typography style={{ color: "green" }}>
                                  Username Available
                                </Typography>
                              ) : usernameAvailable === false ? (
                                <Typography style={{ color: "red" }}>
                                  Username Taken
                                </Typography>
                              ) : (
                                ""
                              )
                            ) : (
                              setusernameAvailable(null)
                            )}

                            <ErrorMessage name="user_code">
                              {(msg) => (
                                <div style={{ color: "red" }}>{msg}</div>
                              )}
                            </ErrorMessage>
                          </Grid>
                        </Grid>
                        <Grid item xs={6}>
                          <Grid container direction="column">
                            <Typography
                              style={{ textAlign: "left" }}
                              className={classes.fieldLabelStyles}
                            >
                              Division<span className={classes.asterisk}> * </span>
                            </Typography>
                            <Select
                              style={{ height: "2em" }}
                              onChange={(value: any) => {
                                setFieldValue("division_id", value);
                              }}
                              options={divisionOptions}
                              value={values.division_id}
                            ></Select>
                            <ErrorMessage name="division_id">
                              {(msg) => (
                                <div style={{ color: "red" }}>{msg}</div>
                              )}
                            </ErrorMessage>
                          </Grid>
                        </Grid>
                        <Grid
                          item
                          xs={6}
                          style={{
                            display: userId !== "new" ? "none" : "block",
                          }}
                        >
                          <Grid container direction="column">
                            <Typography className={classes.fieldLabelStyles}>
                              Password<span className={classes.asterisk}> * </span>
                            </Typography>
                            <TextField
                              variant="outlined"
                              name="pass_code"
                              type="password"
                              onChange={handleChange}
                              value={values.pass_code}
                              inputProps={{ maxLength: 50 }}
                            />
                            <ErrorMessage name="pass_code">
                              {(msg) => (
                                <div style={{ color: "red" }}>{msg}</div>
                              )}
                            </ErrorMessage>
                          </Grid>
                        </Grid>
                        <Grid item xs={6}>
                          <Grid container direction="column">
                            <Typography className={classes.fieldLabelStyles}>
                              Roles<span className={classes.asterisk}> * </span>
                            </Typography>

                            <Select
                              isMulti={true}
                              style={{ minHeight: "2em" }}
                              onChange={(value: any) => {
                                setFieldValue("roles", value);
                              }}
                              options={roleOptions}
                              //maxMenuHeight = {"220px"}
                              isDisabled={
                                user.is_super_admin?false:
                                userId===user.id
                              }
                              value={values.roles}
                            ></Select>

                            <ErrorMessage name="roles">
                              {(msg) => (
                                <div style={{ color: "red" }}>{msg}</div>
                              )}
                            </ErrorMessage>
                          </Grid>
                        </Grid>
                        <Grid
                          item
                          xs={6}
                          style={{
                            display: userId !== "new" ? "none" : "block",
                          }}
                        >
                          <Grid container direction="column">
                            <Typography className={classes.fieldLabelStyles}>
                              Confirm Password<span className={classes.asterisk}> * </span>
                            </Typography>
                            <TextField
                              variant="outlined"
                              name="confirm_pass_code"
                              type="password"
                              onChange={handleChange}
                              value={values.confirm_pass_code}
                              inputProps={{ maxLength: 50 }}
                            />
                            <ErrorMessage name="confirm_pass_code">
                              {(msg) => (
                                <div style={{ color: "red" }}>{msg}</div>
                              )}
                            </ErrorMessage>
                          </Grid>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <Grid
                            container
                            direction="row"
                            spacing={1}
                            justify="flex-end"
                            alignItems="flex-end"
                            className={classes.buttonPosition}
                          >
                            <Grid
                              item
                              xs={6}
                              sm="auto"
                              className={classes.buttonStyle}
                            >
                              <Button
                                variant="contained"
                                color="primary"
                                type="reset"
                                size="medium"
                              >
                                <Typography>Clear</Typography>
                              </Button>
                            </Grid>
                            <Grid
                              item
                              xs={6}
                              sm="auto"
                              className={classes.buttonStyle}
                            >
                              <Button
                                variant="contained"
                                color="primary"
                                type="submit"
                                size="medium"
                              >
                                <Typography>Submit</Typography>
                              </Button>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Form>
              )}
            </Formik>
          </Grid>
        </Paper>
      </div>
    );
};
